import { inject, Injectable } from '@angular/core';
import {
  CheckReminderRequest,
  CheckReminderResponse,
} from '../interfaces/reserve-confirm-reminder.model';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReserveConfirmReminderService {
  http: HttpClient = inject(HttpClient);

  /**
   * 查詢檢查提醒
   * @param request 查詢檢查提醒請求
   */
  checkReminders(
    request: CheckReminderRequest
  ): Observable<ApiResponse<CheckReminderResponse>> {
    return this.http.post<ApiResponse<CheckReminderResponse>>(
      API_ENDPOINTS.CHECK_REMINDER,
      request
    );
  }
}
